import { useCallback, useState } from 'react';

type Props = {
  page?: number;
  pageSize?: number;
  onPageChange?: (page: number, pageSize: number) => void;
  onPageSizeChange?: (pageSize: number) => void;
};
export const usePagination = (props?: Props) => {
  const { onPageChange } = props || {};

  const [page, setPage] = useState(props?.page ?? 1);
  const [pageCount, setPageCount] = useState(0);
  const [pageSize, setPageSize] = useState(props?.pageSize ?? 10);
  const updateCount = useCallback(
    (count: number) => {
      setPageCount(Math.ceil(count / pageSize));
      setPage(1);
    },
    [pageSize]
  );

  const updatePage = useCallback(
    (newPage: number) => {
      if (newPage > pageCount) return;
      setPage(newPage);
      onPageChange?.(newPage, pageSize);
    },
    [pageCount, pageSize, onPageChange]
  );

  return {
    updateCount,
    setPageSize,
    pageSize,
    page,
    pageCount,
    updatePage,
  };
};
